import { getEvents } from '@app/analytics/models/helpers';
import { TagContainer } from '@app/analytics/models/container';
import { ClickOnAccessibilityTopLink } from '@app/core/header/store';

/**
 * When the user clicks on enable/disable accessibility link on the top banner.
 */
const events = getEvents((action: ClickOnAccessibilityTopLink) => [
  {
    type: 'event',
    container: TagContainer.Analytics,
    payload: {
      event: action.payload.event_name
    }
  }
]);

export default events;
